import { incApi } from 'api/inc-api';
import { GetEnvironmentsResult } from './qa-env.types';
import { getEnv } from 'util/getEnv';

const endpoints = incApi.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    getDynamicEnvs: build.query<GetEnvironmentsResult, void>({
      query: () =>
        `${getEnv('REACT_APP_QA_URL')}/incentivio-admin-api/dynamicEnvs`,
      transformResponse: (envs: GetEnvironmentsResult) =>
        envs.map(env => ({
          label: env.environmentName,
          id: `${env.baseUrl}/incentivio-admin-api`,
        })),
    }),
  }),
});

export const { useGetDynamicEnvsQuery } = endpoints;
